export { ShowLogOutScreen } from './LogoutScreen';

import React, { useContext } from 'react';
import { PropsI } from '../../../Core/@types';
import { BlockStack, Frame, Loading, Spinner } from '@shopify/polaris';
import { DIProps, parseJwt, extractUSername } from '../../../Core';
import { StoreDispatcher } from '../../../index';
import { createApp } from '@shopify/app-bridge';
import { Redirect } from '@shopify/app-bridge/actions';
import { getSessionToken } from '@shopify/app-bridge-utils';
import { getDecryptedItem } from '../../../Services/secureSession';
import Loader from '../Loader/Loader';

// used to add hour in current time, used in getClientExpTime()
const env_exp_hours = 3;

let env_user_id = "";

export function getClientExpTime(exp: number, exp_hours?: number | null): boolean {
    const expiryDate = new Date(exp * 1000); // Convert UNIX timestamp to Date
    const currentTime = new Date();

    // Add hours to current time
    const hoursToAdd = exp_hours ?? env_exp_hours;
    currentTime.setHours(currentTime.getHours() + hoursToAdd);

    // If expiry date is earlier than currentTime + offset, it's expired
    return expiryDate >= currentTime;
}

export function RenderSkeleton(props: PropsI) {
    return <Loader/>
    return (
        <div className='custom-loading-app'>
            <Frame>
                {' '}
                <Loading />
                <BlockStack align='center' inlineAlign='center'>
                    <Spinner accessibilityLabel="Spinner example" size="large" />
                </BlockStack>
            </Frame>
        </div>
    );
}

export async function openAppInEmbedded(props: PropsI, refreshData = false) {
    const { location, match, di } = props;
    const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY ?? "";
    const appRoute = process.env.REACT_APP_SHOPIFY_ROUTE + (match['*'] ?? "dashboard");
    const appName = process.env.REACT_APP_SHOPIFY_APP_NAME;

    let host = di.globalState.get("host")
        ?? new URLSearchParams(location.search).get("shopify_host")
        ?? new URLSearchParams(location.search).get("host");

    if (!host || host === "null") {
        const queryParams = getDecryptedItem("queryParams");
        if (queryParams) {
            host = getQueryParam("host", queryParams) ?? getDecryptedItem("host");
        }
    }

    // Final fallback redirect if host is still not available
    if (!host || host === "null") {
        // console.log("fallback");
        window.location.replace(`https://admin.shopify.com/?redirect=/apps/${appName}`);
        return;
    }

    // Initialize App Bridge
    const app = createApp({
        apiKey,
        host,
        forceRedirect: true,
    });
    // console.log({
    //     apiKey,
    //     host,
    //     forceRedirect: true,
    // }, "appbridgecretate");


    // Attempt session token fetch to validate session
    try {
        const token = await getSessionToken(app);
        // console.log("Shopify Session Token:", token);
    } catch (error) {
        console.error("Failed to get session token", error);
    }

    // Redirect with or without refresh query
    const redirectPath = refreshData ? `${appRoute}?refresh=true` : appRoute;
    Redirect.create(app).dispatch(Redirect.Action.APP, redirectPath);
}

// redirect to HOME server ( Back-end ) or Check if token is valid
export function RedirectToHome(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);
    // console.log(params, params.get('shop'), "asdwdcfgfgh");
    const dispatcher = useContext(StoreDispatcher);
    if (params.get('hmac') !== null && params.get('shop') !== null) {
        let url: any =
            props.di.environment.API_ENDPOINT +
            'connector/request/shopifyCurrentRoute?';
        let queryParams = '';
        let end = '';
        for (const param of params) {
            queryParams += end + param[0] + '=' + param[1];
            end = '&';
        }
        url += queryParams + end + 'current_route=' + (props.match['*'] ?? "dashboard");
        props.di.globalState.set('queryParams', queryParams, true);
        //console.log(url, params, "asdfgh", queryParams, getSaveShopData(props, params.get('shop'), params.get('host')));
        if (params.get('host') || getDecryptedItem("host")) {
            // if token is valid, open the app, else redirect to Server
            if (
                getSaveShopData(props, params.get('shop'), params.get('host') ?? getDecryptedItem("host"))
            ) {
                props?.loginStatus?.();
                dispatcher({
                    type: 'user_id',
                    state: {
                        user_id: env_user_id,
                    },
                });
                const params: any = new URLSearchParams(props.location.search);
                //console.log(getSaveShopData, "getSaveShopData", params.get('success'), params.get('message'));

                const success = params.get('success');
                const message = params.get('message');
                if (success && message) {
                    props.history(
                        '/panel/' +
                        env_user_id +
                        '/' +
                        (props.match['*'] ?? "dashboard") +
                        '?success=' +
                        success +
                        '&message=' +
                        message
                    );
                } else {
                    props.history(
                        '/panel/' + env_user_id + '/' + (props.match['*'] ?? "dashboard")
                    );
                }
            } else {
                //console.log("redirect", url);


                // redirect to server
                // https://shopify.dev/apps/tools/app-bridge/actions/navigation/redirect
                appBridgeRedirect(url, props, params.get('host') ?? getDecryptedItem("host"));
            }
        } else {
            //console.log("winnn");

            window.location.replace(url);
        }
    }
    else {
        // console.log('https://admin.shopify.com/apps'
        //     + process.env.REACT_APP_SHOPIFY_APP_BASE
        //     + props.location.pathname, "elseurl");

        const searchParams = new URLSearchParams(window.location.search);
        const success = searchParams.get("success");

        if (success === "false") {
            const message = searchParams.get("message") ?? "";
            // const refresh = searchParams.get("refresh") ?? "";

            // console.log(success, message, "sdf1");

            const appBase = process.env.REACT_APP_SHOPIFY_APP_NAME; // e.g., "shein-sale-channel"
            const fullPath = props.location.pathname; // e.g., "/panel/681dcec8b765550a990dacb2/dashboard"

            // Safely encode the query parameters
            const queryParams = new URLSearchParams({
                success,
                message,
            }).toString(); // Outputs: "success=false&message=state%20not%20found"

            // Construct the final URL
            const finalUrl = `https://admin.shopify.com/apps/${appBase}${fullPath}?${queryParams}`;

            // console.log(finalUrl, "Redirecting");

            appBridgeRedirect(finalUrl, props);
            return;
        }

        // window.location.replace('https://admin.shopify.com');
        appBridgeRedirect('https://admin.shopify.com/apps/'
            + process.env.REACT_APP_SHOPIFY_APP_NAME
            + props.location.pathname, props);
    }
}

function getQueryParam(param: string, query: any) {
    const params = new URLSearchParams(query);
    return params.get(param);
}

export function appBridgeRedirect(
    permissionUrl: string,
    props: any,
    host?: string | undefined | null
) {

    const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY ?? "";
    if (!host || host == "null") {
        host = getDecryptedItem("host");
    }
    //console.log(host, props.di.globalState.get(`host`), getDecryptedItem("host"), props, "jdsvfg", permissionUrl);
    if (window.top == window.self || !host || host == "null") {
        window.location.assign(permissionUrl);
    } else {
        const app = createApp({
            apiKey: apiKey,
            host: host ?? getDecryptedItem("host") ?? "",
        });
        Redirect.create(app).dispatch(Redirect.Action.REMOTE, permissionUrl);
    }
}

// use to open external URL
export function appBridgeRouting(permissionUrl: string, props: any) {

    const apiKey: any = process.env.REACT_APP_SHOPIFY_API_KEY;
    const host = getDecryptedItem("host");
    if (window.top == window.self || !host) {
        props.history('../' + permissionUrl);
    } else {
        const app = createApp({
            apiKey: apiKey,
            host: host,
        });
        Redirect.create(app).dispatch(
            Redirect.Action.APP,
            process.env.REACT_APP_SHOPIFY_ROUTE + permissionUrl
        );
    }
}

function getSaveShopData(props: PropsI, shop: string, host: string) {
    let shopData: any = JSON.parse(
        props.di.globalState.get(`all_shops`, true) ?? '{}'
    );

    if (shopData[shop]) {
        const tokenDecoded = parseJwt(shopData[shop]['token']);

        // check if it time to genarate new token, or use previous one
        if (getClientExpTime(tokenDecoded['exp'])) {
            // set the new HOST
            props.di.globalState.set(`${shopData['user_id']}_host`, host);
            shopData[shop]['host'] = host;

            // used for ROUTING
            env_user_id = shopData[shop]['user_id'];

            // new data updated
            props.di.globalState.set(
                `all_shops`,
                JSON.stringify(shopData),
                true
            );
            return true;
        }
    }
    return false;
}

export function redirectToApp(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);
    const token = params.get('user_token');
    const user_id = params.get('user_id') ?? null;
    const shop = params.get('shop');
    const host = params.get('shopify_host') ?? params.get('host');
    const username = params.get('username') ?? 'User';
    const onboarding = params.get('onboarding');

    if (user_id) {
        //console.log(user_id, "user_id");

        props.di.globalState.set(`${user_id}_user_authenticated`, `true`, true);
        props.di.globalState.set(`${user_id}_auth_token`, token, true);
        props.di.globalState.set(
            `${user_id}_username`,
            extractUSername(username),
            true
        );
        props.di.globalState.set(`${user_id}_shop`, shop, true);
        props.di.globalState.set(`${user_id}_host`, host, true);
    } else {
        //console.log("user_idelse");

        props.di.globalState.set(`user_authenticated`, `true`);
        props.di.globalState.set(`auth_token`, token);
        props.di.globalState.set(`username`, extractUSername(username));
        props.di.globalState.set(`shop`, shop);
        props.di.globalState.set(`host`, host);
    }

    saveTheShopData(props);
    props?.loginStatus?.();
    if (user_id) {
        props.history('/panel/' + user_id + '/' + props.match['*']);
    } else {
        props.history('./' + props.match['*']);
    }
}

// Save the current user data to the localstorage
function saveTheShopData(props: PropsI) {
    const params: any = new URLSearchParams(props.location.search);
    const token = params.get('user_token');
    const shop = params.get('shop');
    const host = params.get('shopify_host') ?? params.get('host');
    const username = params.get('username') ?? 'User';
    const tokenDecoded = parseJwt(token);
    const onboarding = params.get('onboarding');

    let shopData = JSON.parse(
        props.di.globalState.get(`all_shops`, true) ?? '{}'
    );

    shopData[shop] = {
        host: host,
        token: token,
        username: username,
        user_id: tokenDecoded['user_id'],
    };

    if (onboarding) {
        shopData[shop]['onboarding'] = true;
    } else {
        shopData[shop]['onboarding'] = false;
    }
    props.di.globalState.set(`all_shops`, JSON.stringify(shopData), true);
}

export function isAdminLoggedIn() {
    try {
        return getDecryptedItem('admin_login') != null;
    } catch (error) {
        return false;
    }
}

let dataFetch = 'no';
let dataFetchValue = false;
export function showOnlyGrid(user_id: string, props: DIProps) {

    let url = 'frontend/adminpanelamazonmulti/showOnlyGrid';

    if (dataFetch == 'yes') {
        return dataFetchValue;
    }

    if (isAdminLoggedIn()) {
        props.di.GET(url, { user_id: user_id }).then((e) => {
            dataFetch = 'yes';
            if (e.success) {
                dataFetchValue = true;
                return true;
            }
            dataFetchValue = false;
        });
    }
    return false;
}

export interface PanelProps extends DIProps {
    isUserExistsInMultiData?: any;
    name?: string;
    syncNecessaryInfo: ((message?: any) => void) | (() => void);
    syncConnectorInfo: (
        props: any,
        shop_url?: string | null,
        updateCurrentShop?: boolean,
        updateStepStatus?: React.Dispatch<React.SetStateAction<string>>
    ) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
    addAiEnabledOrNot?: (props: any) => void;
    saveCurrentPlanData?: (props: any) => void,

}

export function checkForAutoLogin(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);
    if (params.get('user_token') !== null) {
        return true;
    }
    return false;
}